<template>
  <div class="can_use_coupon_modal_box">
    <b-modal
      ref="modal"
      :id="modalId"
      hide-footer
      centered
      title="可用折價券"
      modal-class="discount-modal"
      @hide="showDiscountCoupon"
    >
      <form>
        <div class="input-area">
          <SingleInput
            v-for="(disCoupon, n) in product.disCoupons"
            :key="n"
            :disCoupon="disCoupon"
            :product="product"
            :productIndex="index"
            v-model="synDisCouponsId"
            @couponDis="setCouponDis"
            @ticketNo="setticketNo"
            @couponInfo="setCouponInfo"
            @isShow="setIsShow"
          />

          <div v-if="noUse" class="no-use">無券可使用(未達金額或此店不適用)</div>

          <p class="red-text">請於折抵期間使用完畢，逾期失效，恕無法展延使用</p>
        </div>

        <div slot="modal-footer" class="modal_footer">
          <div class="text-center">
            <b-btn
              class="hoverFill"
              @click="handleHide"
              v-b-modal="'discoupon_modal' + this.index"
            >
              取消
            </b-btn>
            <a class="btn hoverFill btn-secondary" target="_blank" @click="handleDiscouponInVuex">
              確認
            </a>
          </div>
        </div>
      </form>
    </b-modal>
  </div>
</template>

<script>
import SingleInput from './SingleInput';
import { mapGetters, mapMutations } from 'vuex';

export default {
  components: {
    SingleInput
  },
  props: {
    product: {
      type: Object,
      required: true
    },
    bonusData: {
      type: Object,
      required: true
    },
    index: {
      type: Number,
      required: true
    },
    disCoupons: {
      type: Array,
      required: true
    },
    productDisCouponsId: {
      type: String,
      required: true
    },
    productCouponDis: {
      type: Number,
      required: true
    },
    productTicketNo: {
      type: String,
      required: false
    },
    couponInfo: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      disCouponsId: '',
      couponDis: '',
      ticketNo: '',
      isInputShow:[]
    };
  },
  methods: {
    ...mapMutations('cart', ['setCartProductsDiscount']),
    handleHide() {
      this.$refs.modal.hide();
      this.disCouponsId = '';
      this.couponDis = '';
      this.ticketNo = '';
      this.$emit('update:productCouponDis', '');
      this.$emit('update:productTicketNo', '');
      this.$emit('update:productDisCouponsId', '');
      this.$emit('update:couponInfo', {});
      this.setCartProductsDiscount({
        index: this.index,
        couponDisTemp: '',
        ticketNoTemp: ''
      });
    },
    showDiscountCoupon() {
      this.$bvModal.show('discoupon_modal' + this.index);
    },
    setCouponDis(value) {
      this.$emit('update:productCouponDis', value);
    },
    setticketNo(value) {
      this.$emit('update:productTicketNo', value);
    },

    setCouponInfo(value) {
      this.$emit('update:couponInfo', value);
    },

    setIsShow(value){
      this.isInputShow.push(value);
    },

    handleDiscouponInVuex() {
      this.setCartProductsDiscount({
        index: this.index,
        disCouponsId: this.productDisCouponsId,
        couponDisTemp: this.productCouponDis,
        ticketNoTemp: this.productTicketNo,
        couponInfoTemp: this.couponInfo
      });
      this.$refs.modal.hide();
      this.$bvModal.show('discoupon_modal' + this.index);
    }
  },
  computed: {
    ...mapGetters('cart', ['products']),

    //無可用的折價券
    noUse(){
      if(this.isInputShow.length>0){
        return false
      }else{
        return true
      }
    },

    modalId() {
      return 'can_use_coupon_modal' + this.index;
    },

    synDisCouponsId: {
      get() {
        return this.productDisCouponsId;
      },
      set(val) {
        this.$emit('update:productDisCouponsId', val);
      }
    },
    singleInputLength(){
      return this.product.disCoupons.length
    }
  }
};
</script>
